import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { VlmSettingsKey, VlmTabToggles } from "./VlmTabToggles";

export const VlmTabEditMode = () => {
  const { vlmSettings, vlmCustomCase, vlmConfigLoading, setVlmDraft } =
    useEditCameraStore();

  const handleChange = (key: VlmSettingsKey, checked: boolean) => {
    setVlmDraft({ [key]: checked });
  };

  const handleCustomAnalysisNameChange = (value: string) => {
    setVlmDraft(undefined, value);
  };

  if (vlmConfigLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress color="warning" />
      </Box>
    );
  }

  return (
    <VlmTabToggles
      settings={vlmSettings}
      customAnalysisName={vlmCustomCase}
      disabled={false}
      onChange={handleChange}
      onCustomAnalysisNameChange={handleCustomAnalysisNameChange}
    />
  );
};
